import React from "react";
import Checkbox from "components/Checkbox";
import { useTranslation } from "react-i18next";
import { FormValue } from "../BuildingSettingsStore";
import TextInput from "components/TextInput";
import { M2_DGNB_UNIT } from "utils";

const DGNB18 = (props: {
  tgaFactor?: boolean | null;
  relevantArea?: number | null;
  onChange?: (value: FormValue, name?: string) => void;
  hasError?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white p-4">
      <Checkbox
        checked={Boolean(props.tgaFactor)}
        labelElement={
          <span className="text-sm leading-5 font-medium">
            {t("buildingSettings.reductionOfTheTGAfactor")}
          </span>
        }
        name="reduce_tga_factor_to_1_1"
        containerClassName="mb-4 !py-0"
        onChange={(e) =>
          props.onChange?.(e.currentTarget.checked, "reduce_tga_factor_to_1_1")
        }
      />
      <TextInput
        type="number"
        placeholder={t("buildingSettings.pleaseSpecifyTheArea")}
        labelName={t("buildingSettings.DGNBDesignArea")}
        noMargin
        required
        value={String(props.relevantArea ?? "")}
        handleChange={(value) => props.onChange?.(value, "relevant_area")}
        helper={t("buildingSettings.DGNBDesignAreaDesc")}
        showMandatoryAlert={props.hasError && !props.relevantArea}
        unit={M2_DGNB_UNIT}
      />
    </div>
  );
};

export default DGNB18;
